export default "__VITE_PUBLIC_ASSET__c0d20354__"